<template>
  <div class="preika-auth-page">
    <section class="preika-error-panel">
      <img
        src="/img/avatars/preika_black.png"
        :alt="productName"
        class="preika-error-panel__logo"
      >
      <span class="preika-error-panel__icon">
        <CIcon name="cil-x-circle"/>
      </span>
      <h1>処理を完了できませんでした</h1>
      <p>
        ページへのアクセス中にエラーが発生しました。
        セッションの有効期限が切れている可能性があるため、再度ログインしてください。
      </p>
      <div class="preika-error-panel__actions">
        <router-link :to="{ name: 'Login' }" class="btn btn-primary">
          ログイン画面へ
          <CIcon name="cil-arrow-right"/>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { PRODUCT_NAME } from '@/common/productName'

export default {
  name: 'UserError',

  computed: {
    /** 売るときの正式な表記。**1か所から取る。** */
    productName () {
      return PRODUCT_NAME
    }
  },
}
</script>

<style scoped>
.preika-error-panel {
  position: relative;
  z-index: 1;
  width: min(100%, 620px);
  padding: 52px;
  border: 1px solid rgba(255, 255, 255, .85);
  border-radius: 25px;
  background: rgba(255, 255, 255, .95);
  box-shadow: 0 30px 80px rgba(7, 52, 87, .17);
  text-align: center;
}

.preika-error-panel__logo {
  width: 150px;
  max-height: 48px;
  margin-bottom: 25px;
  object-fit: contain;
}

.preika-error-panel__icon {
  display: inline-flex;
  width: 70px;
  height: 70px;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  border-radius: 23px;
  background: var(--preika-danger-100);
  color: var(--preika-danger-600);
  font-size: 34px;
}

.preika-error-panel h1 {
  margin: 14px 0 12px;
  color: var(--preika-navy-900);
  font-size: 24px;
}

.preika-error-panel p {
  max-width: 470px;
  margin: 0 auto;
  color: var(--preika-text-muted);
  font-size: 12px;
  line-height: 1.9;
}

.preika-error-panel__actions {
  display: flex;
  justify-content: center;
  margin-top: 28px;
}

@media (max-width: 575.98px) {
  .preika-error-panel {
    padding: 38px 23px;
  }
}
</style>
